import service from "@/utils/http/axios";
import { stringify } from 'qs';


interface ParamsType{
  index?: string
  page: string
  num?: string
}

export const serviceGET = (params : ParamsType) => service.get(`api/get?${stringify(params)}`)

export const servicePOST = (data : ParamsType) => service.post(`api/post?`, data)


export const getToken = (data) => service.post(`/thirdRequest/getToken`, data)

export const getIntervieweeEmpInfo = (data) => service.post(`/empInterviewee/getIntervieweeEmpInfo`, data)

export const queryEvaluateLabel = () => service.post(`/empInterviewee/queryEvaluateLabel`)

interface UserEvaluateType{
  mobileNo: string
  workOrderNo: any
  evaluateStar?:string | number
  evaluateIds?: object
  evaluateMsgs?: object
  evaluateMsg?:string
}

export const saveUserEvaluate = (data:UserEvaluateType) => service.post(`/empInterviewee/saveUserEvaluate`, data)

interface MobileNoType{
  mobileNo?: string
}
export const getEmpIntervieweeMobileVerifyCode = (data:MobileNoType) => service.post(`/empInterviewee/getEmpIntervieweeMobileVerifyCode`, data)

interface OrderListType{
  mobileNo: string
  qrCodeId:any
  verifyCode: string | number
}

export const queryCustomerThreeMonthOrderList = (data:OrderListType) => service.post(`/empInterviewee/queryCustomerThreeMonthOrderList`, data)


interface SignatureType{
  url: string
}
export const getSignature = (params:SignatureType) => service.post(`/empInterviewee/getSignature?${stringify(params)}`)

export const getWeiXinOpenLink = () => service.post(`/empInterviewee/getWeiXinOpenLink`)

// 小票线上化相关接口
interface QueryOnLinePrintTempletType{
  sign: string
  requestSource:number
}
export const queryOnLinePrintTemplet = (data:QueryOnLinePrintTempletType) => service.post(`/thirdRequest/queryOnLinePrintTemplet`, data)
export const readOnLineTempletNotify = (data:QueryOnLinePrintTempletType) => service.post(`/thirdRequest/readOnLineTempletNotify`, data)
export const getOnLineSecurityCheckReportUrl = (data:QueryOnLinePrintTempletType) => service.post(`/thirdRequest/getOnLineSecurityCheckReportUrl`, data)


